import React from "react";
import { connect } from "react-redux";
import { isIOS } from "react-device-detect";
import { bool, shape } from "prop-types";

import { debinStatusActions, statusTagColor } from "util/debin";
import { selectors as debinSelectors } from "reducers/debin";

import useActionByDebinState from "pages/debinPayments/hooks/useActionByDebinState";
import Action from "pages/_components/Action";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import InfoTag from "pages/debinPayments/_components/InfoTag";
import DataScheduledDebinDetail from "./components/DataScheduledDebinDetail";

const ScheduledDebinDetail = ({ scheduledDebin, isDesktop }) => {
    const { options } = useActionByDebinState(debinStatusActions, scheduledDebin, null);

    const Status = () => (
        <InfoTag type="info" message={scheduledDebin?.status} tagBackground={statusTagColor(scheduledDebin?.status)} />
    );

    return (
        scheduledDebin.debin && (
            <>
                <Notification scopeToShow="debin" />
                <ResponsiveHeader
                    id="debin.scheduled.detail.title"
                    backLinkTo="/scheduledDebin"
                    infoComponents={
                        <div className="pl-4">
                            <Status />
                        </div>
                    }>
                    {options.length > 0 && (
                        <>
                            <DesktopButtons moreOptions={options} secondButtonDisabled>
                                {" "}
                                {[]}{" "}
                            </DesktopButtons>
                            <MobileButtons
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }>
                                {options?.map((option) => (
                                    <Action labelKey={option.text} handleClick={option.func} />
                                ))}
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>

                <MainContainer>
                    <DataScheduledDebinDetail scheduledDebin={scheduledDebin} isDesktop={isDesktop} />
                </MainContainer>
            </>
        )
    );
};

ScheduledDebinDetail.propTypes = {
    isDesktop: bool.isRequired,
    scheduledDebin: shape({}).isRequired,
};

const mapStateToProps = (state) => ({
    scheduledDebin: debinSelectors.getScheduledDebin(state),
});

export default connect(mapStateToProps)(ScheduledDebinDetail);
